<script setup lang="ts">
import NavHeader from "@/components/general/NavHeader.vue";
import { appStore } from "@/stores/AppStore";

const store = appStore();

const autoSignInOnDevice = async (): Promise<void> => {
  await store.autoSignInOnDevice("picking");
};

autoSignInOnDevice();
</script>

<template>
  <div class="safe-area-bot min-h-screen bg-neutral-800 flex flex-col">
    <NavHeader app-name="picking" title="Picking" />
    <div class="flex flex-col flex-auto px-4 lg:px-8 py-6">
      <router-view />
      <DynamicDialog />
    </div>
  </div>
</template>

<style lang="scss">
.picking-layout {
  background-color: #282828;
  padding-bottom: env(safe-area-inset-bottom);
}
.bg-header {
  background-color: #141414;
}

@media (max-width: 768px) {
  .sign-in-out-btn {
    padding: 0.5rem;

    .p-button-icon {
      margin-right: 0;
    }

    .p-button-label {
      display: none;
    }
  }
}
</style>
